import { useEffect } from "react";
import { getValueFromStorage, removeValueFromStorage } from "@qlik/qlik/src/lib/util/browser-apis";

/**
 * Check & fire callbacks based on form session in client browser
 * @param {string} formId
 * @param {Function} formValidCallback
 * @param {Function} formInvalidCallback
 * @param {Function} formExpiredCallback
 */
const useFormSession = (
    formId,
    formValidCallback = () => {},
    formInvalidCallback = () => {},
    formExpiredCallback = () => {}
) => {
    useEffect(() => {
        const windowObj = typeof window !== "undefined" ? window : undefined;
        const formSession = getValueFromStorage(formId, windowObj);

        if (!formSession) {
            formInvalidCallback();
            return;
        }

        const { expireAt } = formSession;
        // check if form submission is expired or not
        if (Date.now() > expireAt) {
            // form submission has expired
            removeValueFromStorage(formId, windowObj);
            formExpiredCallback();
            return;
        }

        formValidCallback();
    }, [formId, formExpiredCallback, formInvalidCallback, formValidCallback]);
};

export default useFormSession;
